/**
 * O convite — a superfície pública, e a única tela que não tem sessão.
 *
 * Ligar o estado à tela é tudo o que este arquivo faz. A separação existe para
 * que a tela possa ser renderizada inteira sem rede: `useConvite` fala com as
 * três funções `security definer`, `TelaDoConvite` não sabe que elas existem.
 */

import { useConvite } from '../../ganchos/useConvite';
import type { ServicoDoConvite } from '../../servicos/convite';
import { TelaDoConvite } from './TelaDoConvite';

export type PropsDoConvite = {
  readonly token: string;
  /** Só o teste passa: é a costura que troca as três RPCs por um dublê. */
  readonly servico?: ServicoDoConvite;
};

export function Convite({ token, servico }: PropsDoConvite) {
  const { estado, enviar, reabrir, naoSouEu } = useConvite(token, servico);
  return (
    <TelaDoConvite estado={estado} aoEnviar={enviar} aoReabrir={reabrir} aoNaoSerVoce={naoSouEu} />
  );
}

export { TelaDoConvite } from './TelaDoConvite';
